import type { RtdbClient } from '@akpl/firebase/client';
import { PlayerCommandNode, rtdbPaths } from '@akpl/shared';

import { getLiveClient } from './client';

export type CommandCallback = (command: PlayerCommandNode) => void;

/**
 * Remote commands from the phones (docs/04 §4.4): every distinct `command.id` on
 * `/sessions/{sid}/player/command` is delivered once. RTDB re-emits the node on reconnect and
 * on any sibling write, so the id is what dedupes — not the arrival.
 *
 * The node still holds the last command when the TV subscribes, so the first callback may be
 * a command the session already acted on; the player checks `command.at` / its own state
 * before obeying (it also keeps `lastCommandId` in the store across screens).
 */
export function subscribeCommands(
  sid: string,
  cb: CommandCallback,
  client: RtdbClient | null = getLiveClient(),
): () => void {
  if (!client) return () => {};
  let lastId: string | null = null;
  return client.listen(rtdbPaths.playerCommand(sid), PlayerCommandNode, (command) => {
    if (!command || command.id === lastId) return;
    lastId = command.id;
    cb(command);
  });
}
